import mapboxgl from "mapbox-gl";
import { createPopup } from "./popupUtils";
import { Space } from "types/Space";

export const createMarkerElement = (space: Space): HTMLDivElement => {
	const el = document.createElement("div");
	el.className = "personal-space-marker";
	el.innerHTML = space.icon;
	el.style.backgroundColor = space.color ?? "";
	return el;
};

export const createMarker = (
	space: Space,
	lngLat: mapboxgl.LngLat,
	map: mapboxgl.Map,
	options: Partial<mapboxgl.MarkerOptions> = {}
): mapboxgl.Marker => {
	const el = createMarkerElement(space);
	const popup = createPopup(space.label);

	const marker = new mapboxgl.Marker({
		element: el,
		draggable: true,
		scale: 1,
		anchor: "center",
		...options,
	})
		.setLngLat(lngLat)
		.setPopup(popup)
		.addTo(map);

	return marker;
};

export const removeMarker = (marker: mapboxgl.Marker | null) => {
	if (marker) {
		marker.remove();
	}
};

export const updateMarkerPosition = (
	marker: mapboxgl.Marker | null,
	lngLat: mapboxgl.LngLat
) => {
	if (marker) {
		marker.setLngLat(lngLat);
	}
};
